import React, { Component } from 'react';
// react component for creating dynamic tables
import ReactTable from 'react-table';
import {
  Grid,
  Row,
  Col,
  Navbar,
  FormGroup,
  FormControl,
  InputGroup,
} from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as ReasonsActions from './redux/ReasonsActions';

class ReasonsIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
    console.log('Props', props);
  }

  componentWillMount() {
    this.props.find({});
  }

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  render() {
    let _this = this;
    let { history, Reasons } = this.props;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    {'Lista de causas de Cotizaciones caídas'}{' '}
                    <div className="pull-right header-table">
                      <Button
                        bsStyle="primary"
                        wd
                        onClick={() =>
                          history.push('/admin/config/reasons/create')
                        }
                      >
                        Agregar Causa
                      </Button>
                      <Navbar.Form pullLeft className="navbar-search-form">
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon>
                              <i className="fa fa-search" />
                            </InputGroup.Addon>
                            <FormControl
                              type="text"
                              placeholder="Buscar..."
                              value={Reasons.search}
                              onChange={this.search.bind(this)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Navbar.Form>
                    </div>
                    <div className="clearfix" />
                  </div>
                }
                ctFullWidth
                content={
                  <ReactTable
                    data={
                      Reasons.searchData ? Reasons.searchData : Reasons.data
                    }
                    page={Reasons.table.page}
                    sorted={Reasons.table.sorted}
                    filtered={Reasons.table.filtered}
                    pageSize={Reasons.table.pageSize}
                    onSortedChange={(change) =>
                      _this.props.changeTable('sorted', change)
                    }
                    onFilteredChange={(change) =>
                      _this.props.changeTable('filtered', change)
                    }
                    onPageChange={(change) =>
                      _this.props.changeTable('page', change)
                    }
                    onPageSizeChange={(change) =>
                      _this.props.changeTable('pageSize', change)
                    }
                    previousText={'Anterior'}
                    nextText={'Siguiente'}
                    loadingText={'Cargando...'}
                    noDataText={'No se encontraron registros'}
                    pageText={'Página'}
                    ofText={'de'}
                    rowsText={'filas'}
                    columns={[
                      {
                        Header: 'Nombre',
                        accessor: 'name',
                      },

                      {
                        Header: 'Acciones',
                        accessor: 'actions',
                        sortable: false,
                        filterable: false,
                        Cell: (props) => (
                          // we've added some custom button actions
                          <div className="actions-right">
                            {/* use this button to add a edit kind of action */}
                            <Button
                              onClick={() =>
                                history.push(
                                  '/admin/config/reasons/' + props.original.id
                                )
                              }
                              bsStyle="warning"
                              simple
                            >
                              Editar
                            </Button>{' '}
                          </div>
                        ),
                      },
                    ]}
                    className="-striped -highlight"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Reasons: state.Reasons,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ReasonsActions, dispatch);
};

const ReasonsConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReasonsIndex);

export default ReasonsConnect;



// WEBPACK FOOTER //
// ./src/views/Reasons/ReasonsIndex.jsx